import {  axiosMock } from '../client';
import { API_URL } from '../apiDictionary';
import { createPaginatedQCList } from '../../mocks/qcList';


type PaginatedArgs = {
  page?: number;
  size?: number;
};

export const fetchQCTasksMock = async (args?: PaginatedArgs) => {
  const data = createPaginatedQCList({
    page: 0,
    size: 100,
  });

  axiosMock.onGet(API_URL.qcTasks).reply(200, data);
  axiosMock.onGet(API_URL.qcTasks, {
    params: {
      page: args?.page,
      size: args?.size,
    },
  });
};
